import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { UserAvatarUploadData } from './userService';

import { UserService } from './userService';

export function usePostUserAvatar() {
  const postUserAvatarMutation = useMutation({
    mutationFn: (data: UserAvatarUploadData) => UserService.upsertUserAvatar(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(postUserAvatarMutation.error, baseErrorMessages);
  return { ...postUserAvatarMutation, errorMessage };
}
